<div class="container">
  <div class="icon">
    <mat-icon fontSet="mdi" [inline]="true" [fontIcon]="icon"></mat-icon>
  </div>
  <div class="content">
    <h1>{{ title }}</h1>
    <span>{{ description }}</span>
    <div *ngIf="showButton" class="actions">
      <button mat-flat-button color="primary" (click)="onClick()">{{ buttonText | uppercase }}</button>
    </div>
  </div>
</div>
